import { countries } from "../shared/grailConstants";
import type { Country } from "../shared/types";

export function getCountryCodeFromCountryString(country: string) {
    return countries.find((c: Country) => c.label === country)?.code;
}

export function getCountryFromLabelOrString(country: Country | string | undefined | null) {
    if (!country) {
        return null;
    }
    if (typeof country === "string") {
        return country;
    }
    return country.label;
}

export function getCountryFlagURLFromCountryOrString(country: Country | string | undefined | null) {
    if (!country) {
        return null;
    }
    if (typeof country === "string") {
        if (country === "UK") {
            return `https://flagcdn.com/w20/gb.png`;
        }
        if (country === "USA") {
            return `https://flagcdn.com/w20/us.png`;
        }
        const countryCode = getCountryCodeFromCountryString(country);
        return `https://flagcdn.com/w20/${countryCode?.toLowerCase()}.png`;
    }
    return `https://flagcdn.com/w20/${country.code.toLowerCase()}.png`;
}
